import React from "react";
import {generateConsistentColor, getTextColor} from "../Components/ColorUtils";

export const badgeStyle: React.CSSProperties = {
    backgroundColor: '#e9ecef',
    color: '#495057',
    padding: '4px 8px',
    borderRadius: '16px',
    fontSize: '14px',
    marginLeft: '10px',
    fontWeight: 500
};

export const colorStyles = {
    multiValue: (styles, { data }) => ({
        ...styles,
        backgroundColor: generateConsistentColor(data.label),
        borderRadius: '12px',
        padding: '0 4px'
    }),
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: getTextColor(generateConsistentColor(data.label)),
        fontWeight: 500
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: getTextColor(generateConsistentColor(data.label)),
        ':hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            color: getTextColor(generateConsistentColor(data.label))
        }
    }),
    option: (styles, { data }) => ({
        ...styles,
        display: 'flex',
        alignItems: 'center',
        ':before': {
            content: '""',
            display: 'block',
            width: '12px',
            height: '12px',
            marginRight: '8px',
            backgroundColor: generateConsistentColor(data.label),
            borderRadius: '50%'
        }
    })
};

export const slugStyle: React.CSSProperties = {
    fontWeight: 600,
    background: '#f2f2f2',
    border: '1px solid #e0e0e0',
    borderRight: 'none',
    borderRadius: '4px 0 0 4px',
    padding: '0.5rem 0.75rem',
    fontSize: '1rem',
    color: '#555',
    position: 'relative',
    top: '2px'
};